import React from "react";
import {Link} from "react-router-dom";

class RentBanner extends React.Component {
  render() {
    return (
        <section className="header_section header_section_rent">
          {/* <div className="bg-overlay" / >*/}
          <div className="container">
            <div className="row">

              <div className="col-lg-7 desktop-header">
                <h1 className="sub no-margin bold600 mb-2">Meet The World!</h1>
                <p className="mb-4">Make Travelling Fun with MightyWifi</p>
                <div className="row">
                  <div className="col-lg-3 text-center">
                    <div className="rent-price">
                      <p className="m-0">As low as</p>
                      <h1 className="SansSerif bold600 bigfont">$3</h1>
                    </div>
                  </div>
                  <div className="col-lg-9">
                    <strong>CONNECT UP TO 10 DEVICES</strong><br/>
                    {/*<strong>UNLIMITED DATA*</strong><br/>*/}
                    <strong>NO CONTRACT</strong><br/>
                    <span className="notice">
                      {/** After data cap per day, speed limited to maximum of 128kbps.*/}
                      Daily US Rental data Cap : 1 GB
                  </span>
                  </div>
                </div>
              </div>

              <div className="col-lg-5"></div>


              {/*
            <div className="mobile-header">
              <h2 className="SansSerif bold600 m-title-positon">
                <span className="line-break m-header-mtitle Serif">Coming Soon</span>
                <span className="line-break m-header-stitle">2ND generation of global wifi hotspot</span>
                MightyWifi Cloud
              </h2>
            </div>
            */}
            </div>
          </div>
          <div id="RentSection"></div>
        </section>
    );
  }
}

export default RentBanner;



// WEBPACK FOOTER //
// ./src/pages/rent/RentBanner.js